/* eslint-disable @typescript-eslint/camelcase */
import { jsPDF } from "jspdf";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { layoutSection } from "../layout";
import { uploadFile } from "../auto-print";
import messageModal from "@/app/infrastructures/misc/common-library/MessageModal";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { createI18n } from "vue-i18n";
import { getDataSessionStorage } from '@/app/infrastructures/misc/SessionStorage';

const i18nInstance = createI18n({
  legacy: false,
  locale: getDataSessionStorage("countryCode") || "id",
  fallbackLocale: "id",
  globalInjection: false,
  messages: {
    en,
    id,
    my
  }
});

const translate = i18nInstance.global.t;

const openTab = (doc: any, newTab: boolean, stt: string) => {
  doc.setProperties({
    title: `resi-thermal - ${stt}.pdf`
  });

  doc.autoPrint();
  if (newTab) {
    window.open(doc.output("bloburl"), "_blank");
  } else {
    window.location.replace(doc.output("bloburl"));
  }
};

export const regularBook = async (
  autoPrint: boolean,
  newTab: boolean,
  doc: jsPDF,
  data: PrintDataEntitas
) => {
  if (autoPrint) {
    const print = await uploadFile(doc.output("blob"), data.sttNo, false);
    if (!print) {
      openTab(doc, newTab, data.sttNo);
      messageModal(
        translate("bulkPrintResi.modalFailedTitle"),
        "circle-error",
        translate("bulkPrintResi.modalFailedMessage")
      );
    } else {
      messageModal(
        translate("bulkPrintResi.modalSuccessTitle"),
        "badge-success",
        translate("bulkPrintResi.modalSuccessMessage")
      );
    }
  } else {
    openTab(doc, newTab, data.sttNo);
  }
};

export const instanBook = async (doc: jsPDF, data: PrintDataEntitas) => {
  const print = await uploadFile(doc.output("blob"), data.sttNo, true);
  return print;
};

const generatePDF = async (
  bookingType: string,
  accountType: string,
  data: PrintDataEntitas,
  barcode: string,
  vendorRefCode: string,
  barcodeValue: string,
  vendorRefCodeValue: string,
  logo: string,
  shipmentId: string,
  newTab = true,
  language = "id",
  autoPrint = false,
  isBookInstan = false
) => {
  MainAppController.showLoading();
  try {
    const doc: any = new jsPDF("p", "mm", "a6", true);

    let index = 0;
    for (const item of data.sttPieces) {
      if (index > 0) {
        doc.addPage("a6", "p");
      }
      await layoutSection(
        {
          doc,
          bookingType,
          accountType,
          data,
          pieceData: item,
          barcode,
          vendorRefCode,
          barcodeValue,
          vendorRefCodeValue,
          logo,
          shipmentId,
          startX: 0,
          startY: 0
        },
        language
      );

      index++;
    }

    doc.setProperties({
      title: `resi-thermal - ${data.stt}.pdf`
    });

    if (isBookInstan) {
      return instanBook(doc, data);
    } else {
      return regularBook(autoPrint, newTab, doc, data);
    }
  } finally {
    MainAppController.closeLoading();
  }
};

export default generatePDF;
